import { CreateOrderRequest } from '@models/order';
import { PayloadAction, WritableDraft } from '@reduxjs/toolkit';

export function copy(
    state: WritableDraft<CreateOrderRequest>,
    payload: PayloadAction<CreateOrderRequest>,
) {
    Object.assign(state, payload.payload);
}
